<template>
  <div id="projectpage">
    <div class="header">
      <v-container class="nopadding">
        <v-row>
          <v-col align="center" class="nonothing">
            <h1>
              <a href="/" v-if="publicPoll && publicPoll.data">
                {{ publicPoll.data.name }}
              </a>
            </h1>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <article class="maxwidth contentheight">
      <v-container>
        <SnackBarSuccess
          ref="successSnackbar"
          position="top"
          :msg="successSnackbarMsg"
        ></SnackBarSuccess>
        <ErrorSnackbar
          ref="errorSnackbar"
          position="top"
          :msg="errorSnackbarMsg"
        ></ErrorSnackbar>

        <!-- BREADCRUMBS -->
        <v-row no-gutters id="breadcrumbsproject">
          <v-col cols="9" sm="9" md="10">
            <p class="breadcrumbs">
              <router-link :to="'/'" class="pointer">Vitrine</router-link> »
              <span v-if="showField('nameOfProject')">
                {{ project.nameOfProject }}
              </span>
              <span v-if="!showField('nameOfProject')"> Projeto </span>
            </p>
          </v-col>

          <v-col cols="3" sm="3" md="2" class="text-right">
            <p class="breadcrumbs">
              <router-link :to="'/'" class="pointer">
                <i class="material-icons">reply</i>
                <span>Voltar</span>
              </router-link>
            </p>
          </v-col>
        </v-row>
        <!-- BREADCRUMBS -->

        <v-card class="mx-auto" max-width="100%">
          <div class="profile-headerbg">
            <img v-if="project && project.slider" :src="project.slider" />
            <div class="degrade" style="min-height: auto"></div>
          </div>

          <div class="profile-infos">
            <v-row class="profile_img">
              <v-col
                cols="12"
                xs="12"
                sm="3"
                md="2"
                order="1"
                class="perfilwithlogo"
                v-if="project"
              >
                <img class="profile-avatar right"
                  :src="
                    project.logo
                      ? project.logo
                      : 'https://prosas.com.br/img/proposallogo.jpg'
                  "
                 />
              </v-col>

              <v-col
                id="projecttitles"
                cols="12"
                xs="12"
                sm="9"
                md="10"
                order="2"
                class="nopadding"
              >
                <div class="profile_info">
                  <div class="titletable" v-if="showField('nameOfProject')">
                    <h1 class="titles_pages_internas">
                      {{ project.nameOfProject }}
                    </h1>
                  </div>
                </div>

                <v-row v-if="project && showField('projectStatus')">
                  <v-col>
                    <p class="nonothing">
                      <!-- INSERIR A VALIDAÇÃO v-if="showField('situationOfProject')"  -->
                      <span class="titlestatus">Status de avaliação da proposta:</span>
                      <span
                        v-if="
                          project.status == '' ||
                          !project.status ||
                          project.status == 'p_aprovada' ||
                          project.status == 'p_reprovada' ||
                          project.status == 'em_diligencia' ||
                          project.status == 'diligencia_respondida' ||
                          project.status == 'processo_encerrado'
                          
                        "
                        class="badge"
                      >
                        Em Análise
                      </span>
                      <span
                        v-if="
                          project.status == 'aprovada' ||
                          project.status == 'proposta_aprovada'
                        "
                        class="badge"
                      >
                        Aprovada
                      </span>
                      <span
                        v-if="
                          project.status == 'reprovada' ||
                          project.status == 'proposta_reprovada'
                        "
                        class="badge"
                      >
                        Reprovada
                      </span>
                    </p>
                  </v-col>

                  <v-col v-if="showField('idwall_status')">
                    <p class="nonothing">
                      <span class="titlestatus">Status do Compliance:</span>
                      <span class="badge" v-if="project.idwall_status">
                        {{ project.idwall_status }}
                      </span>
                    </p>
                  </v-col>

                  <v-col>
                    <p
                      class="tipo_pessoa subtitulo"
                      v-if="!siteConfiguration.scoreAsPrivate && votingPortal"
                    >
                      {{
                        project && project.totalVotes ? project.totalVotes : 0
                      }}
                      <span
                        v-if="
                          project &&
                          (!project.totalVotes || project.totalVotes <= 1)
                        "
                        >Voto</span
                      >
                      <span
                        v-if="
                          project &&
                          project.totalVotes &&
                          project.totalVotes > 1
                        "
                        >Votos</span
                      >
                    </p>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
        </v-card>

        <v-row>
          <v-col cols="12" xs="12" sm="12" md="8">
            <!-- TIMETOVOTING -->
            <v-card v-if="votingPortal" id="votingcard">
              <v-row v-if="onTimeToVoting === 'before'" class="nonothing">
                <v-col class="votingcardinfo">
                  <p>A votação iniciará em:</p>
                  <h3
                    class="hour-format-h3"
                    v-if="
                      publicPoll &&
                      publicPoll.configuration &&
                      publicPoll.configuration.deadlineForVotingOnProjects
                    "
                  >
                    {{
                      formatDate(
                        publicPoll.configuration.deadlineForVotingOnProjects
                          .from
                      )
                    }}
                  </h3>
                  <label class="lbl-hour-description"
                    >GMT-03 (Horário Padrão de Brasília)</label
                  >
                </v-col>
              </v-row>

              <v-row
                v-else-if="onTimeToVoting === 'not_publish'"
                class="nonothing"
              >
                <v-col class="votingcardinfo">
                  <p>A votação será publicada em:</p>
                  <h3
                    class="hour-format-h3"
                    v-if="publicPoll && publicPoll.configuration"
                  >
                    {{ formatDate(publicPoll.configuration.publicationDate) }}
                  </h3>
                  <label class="lbl-hour-description"
                    >GMT-03 (Horário Padrão de Brasília)</label
                  >
                </v-col>
              </v-row>

              <v-row v-else-if="onTimeToVoting === 'on_time'" class="nonothing">
                <v-col cols="12" sm="9" md="9" class="votingcardinfo">
                  <p>Votação aberta:</p>
                  <h3
                    v-if="
                      publicPoll &&
                      publicPoll.configuration &&
                      publicPoll.configuration.deadlineForVotingOnProjects
                    "
                  >
                    {{
                      formatDate(
                        publicPoll.configuration.deadlineForVotingOnProjects
                          .from
                      )
                    }}
                    <span>até</span>
                    {{
                      formatDate(
                        publicPoll.configuration.deadlineForVotingOnProjects.to
                      )
                    }}
                  </h3>
                  <label class="lbl-hour-description"
                    >GMT-03 (Horário Padrão de Brasília)</label
                  >
                  <v-sheet class="text-body-2">
                    <p class="obsenvio">
                      Após o término do período de votação nenhum voto será
                      confirmado, mesmo se você já tiver requisitado o email com
                      o link do seu voto.
                    </p>
                  </v-sheet>
                </v-col>

                <v-col cols="12" sm="3" md="3" id="votingcardbutton">
                  <FormDialogVote
                    type="link"
                    :emailRestriction="votingRestrictionByEmail"
                    :projectId="project.id"
                    showSuccessAlert="onSuccess"
                    showErrorAlert="onError"
                    @onSuccess="showSuccessAlert"
                    @onError="showErrorAlert"
                  />
                </v-col>
              </v-row>

              <v-row v-else-if="onTimeToVoting === 'after'" class="nonothing">
                <v-col class="votingcardinfo">
                  <p>Votação encerrada em:</p>
                  <h3
                    class="hour-format-h3"
                    v-if="
                      publicPoll &&
                      publicPoll.configuration &&
                      publicPoll.configuration.deadlineForVotingOnProjects
                    "
                  >
                    {{
                      formatDate(
                        publicPoll.configuration.deadlineForVotingOnProjects.to
                      )
                    }}
                  </h3>
                  <label class="lbl-hour-description"
                    >GMT-03 (Horário Padrão de Brasília)</label
                  >
                </v-col>
              </v-row>
            </v-card>
            <!-- TIMETOVOTING -->

            <v-card class="mx-auto nonothing">
              <v-card-text class="text--primary nonothing">
                <v-tabs
                  v-model="currentTab"
                  background-color="transparent"
                  color="primary"
                >
                  <v-tab v-for="item in tabs" :key="item.name">
                    {{ item && item.name ? item.name : "" }}
                  </v-tab>
                </v-tabs>

                <v-tabs-items v-model="currentTab">
                  <v-tab-item v-for="item in tabs" :key="item.name">
                    <v-card flat>
                      <component
                        :is="item.component"
                        project="project"
                        siteConfiguration="siteConfiguration"
                      ></component>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="4">
            <v-card
              class="mx-auto card-entrepreneur"
              v-if="project && project.entrepreneur && showField('entrepreneurName')"
            >
              <div class="white--text align-self-center">
                <v-img
                  class="white--text align-self-center"
                  height="123px"
                  :src="
                    project && project.entrepreneur.slider
                      ? project.entrepreneur.slider
                      : 'https://dummyimage.com/1140x110/242424/242424'
                  "
                >
                </v-img>
              </div>

              <div id="infoentrepreneur">
                <v-avatar
                  v-if="
                    project && project.entrepreneur && project.entrepreneur.logo
                  "
                  size="120"
                  class="avatar-img"
                >
                  <img
                    class="image-logo-entrepeneur"
                    :src="project.entrepreneur.logo"
                    alt="Logo - Empreendedor"
                  />
                </v-avatar>

                <div class="avatar">
                  <div
                    class="avatar-name"
                    v-if="
                      project &&
                      project.entrepreneur &&
                      project.entrepreneur.name
                    "
                  >
                    <a
                      class="title-green"
                      @click="openProsasEntrepeneur(project.entrepreneur.id)"
                      >{{ project.entrepreneur.name }}</a
                    >
                  </div>
                  <div class="avatar-subtitle profile-logo-infos">
                    Empreendedor deste Projeto
                  </div>
                </div>
              </div>
            </v-card>

            <v-card
              class="mx-auto nopadding"
              max-width="100%"
              v-if="
                project &&
                showField('movies') &&
                project.movies &&
                project.movies.length > 0
              "
            >
              <v-card-title>
                <p class="sub_titles">Mídia</p>
              </v-card-title>
              <v-card-text class="text--primary">
                <div>
                  <span class="subtitle">Vídeos</span>
                  <br />
                  <ul id="items-movie">
                    <li v-for="movie in project.movies" :key="movie.id">
                      <div v-if="movie && movie.config && movie.config.link">
                        <label class="des-movie"
                          >Vídeo {{ movie.name }} do projeto
                          {{ project.nameOfProject }}</label
                        >
                        <center
                          v-if="
                            movie.config.type === 'youtube' ||
                            movie.config.type === 'vimeo'
                          "
                        >
                          <br />
                          <iframe
                            :src="movie.config.link"
                            frameborder="0"
                            allowfullscreen
                            class="vid_you"
                          ></iframe>
                        </center>
                        <div
                          class="href-midia"
                          v-else-if="movie.config.type === 'any'"
                        >
                          <br />
                          <a target="__new" :href="movie.config.link">{{
                            movie.config.link
                          }}</a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </v-card-text>
            </v-card>

            <v-card class="mx-auto nopadding" max-width="100%">
              <v-card-title>
                <p class="sub_titles">Compartilhe esta página</p>
              </v-card-title>

              <v-card-text class="text--primary" id="social-network">
                <ul class="text-center social-network">
                  <li>
                    <a @click="openFacebookDialog()" href="javascript:">
                      <v-icon large>mdi-facebook</v-icon>
                    </a>
                  </li>

                  <li>
                    <a
                      href="javascript:"
                      @click="openTwitterDialog()"
                      class="twitter-share"
                      data-lang="pt"
                      data-count="none"
                    >
                      <v-icon large>mdi-twitter</v-icon>
                    </a>
                  </li>

                  <li>
                    <a
                      href="javascript:"
                      @click="openLinkedinDialog()"
                      class="linkedin-share"
                      data-lang="pt"
                      data-count="none"
                    >
                      <v-icon large>mdi-linkedin</v-icon>
                    </a>
                  </li>

                  <li>
                    <a
                      href="mailto:?subject=Prosas&amp;body=https://prosas.com.br"
                      class="email-share"
                      data-lang="pt"
                      data-count="none"
                    >
                      <v-icon large>mdi-gmail</v-icon>
                    </a>
                  </li>
                </ul>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </article>

    <v-footer class="foot">
      <v-layout justify-start>
        <span class="terms"
          ><a href="https://prosas.com.br/termos" target="_blank"
            >Termos de uso e política de privacidade</a
          ></span
        >
      </v-layout>
      <v-layout justify-end>
        <span class="copy">Copyright 2022 &copy; Prosas</span>
        <div id="buttonwhatsapp" class="buttonwhatsapp" style="background-color: #075E54 !important;">
          <a href="https://wa.me/553199198781?text=Olá,+preciso+de+ajuda." target="_blank">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 4 35 14">
              <path fill="#fff"
                d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" />
            </svg>
            <h5 class="buttonwhatsappHelp">Ajuda</h5>
          </a>
        </div>
      </v-layout>
    </v-footer>
      
  </div>
</template>


<script>
import { mapState, mapActions } from "vuex";
import { expiredTokenMessage } from "@/const/poll/voteToken";
import SnackBarSuccess from "@/components/utils/SnackbarSuccess";
import ErrorSnackbar from "@/components/utils/SnackbarError";
import FormDialogVote from "@/components/form/voteonTheProject/VoteForm.vue";

import PollViewEntrepreneur from "@/components/poll/view/Entrepreneur.vue";
import PollViewProject from "@/components/poll/view/Project.vue";
import PollViewEvaluation from "@/components/poll/view/Evaluation.vue";

import { getBRDateTime } from "@/utils/DateUtils";
import moment from "moment";

export const DATA = {
  celular: "(31) 99898-9898",
};

const initialTabs = [
  {
    name: "Proposta",
    component: PollViewProject,
  },
];

export default {
  components: {
    FormDialogVote,
    SnackBarSuccess,
    ErrorSnackbar,
    PollViewEntrepreneur,
    PollViewProject,
    PollViewEvaluation,
  },

  data: () => ({
    // Controls the functions called after the enterelly page documente is ready
    readyRoutineCompleted: false,
    tab: null,
    domain: '',
    successSnackbarMsg: "",
    errorSnackbarMsg: "",
    currentTab: null,
    tabs: initialTabs,
    siteConfiguration: {
      publicationDate: "",
      deadlineForVotingOnProjects: "",
      customLink: "",
      projectDataForDisplay: {
        nameOfProject: false,
        description: false,
        actingLocations: false,
        ods: false,
        sites: false,
        areasOfInterest: false,
        complementaryFiles: false,
        subareasOfInterest: false,
        targetsAudience: false,
        fundingSource: false,
        movies: false,
      },
      scoreAsPrivate: false,
      voteLimitPerEmail: null,
      votingRestrictionByEmail: null,
    },
  }),

  async beforeCreate() {
    const projectId = this.$route.params.id;
    const domain = this.$route.params.domain;
    await this.$store.dispatch("getPublicPoll", { domain });
    await this.$store.dispatch("getProjectData", {
      projectId,
      domain,
    });

    await this.$store.dispatch("getPublicProjectAnswers", {
      projectId,
      domain
    });

    await this.$store.dispatch("getPublicProjectQuestionAnswers", {
      projectId,
      domain
    });

    await this.$store.dispatch("getPublicProjectEvaluations", {
      projectId,
      domain
    });

    if (this.publicPoll) {
      await this.setPublicPollConfigurations();
    }
    if (this.project) {
      await this.checkSocialMovies();
    }
  },
  created(){
    this.domain = this.$route.params.domain
  },

  updated() {
    if (this.readyRoutineCompleted) return;

    // Vote validation
    if (this.$route.query && this.$route.query.vote) {
      if (document.readyState === "complete") {
        this.readyRoutineCompleted = true;
        this.$nextTick(function () {
          this.validateToken(this.$route.query.vote);
        });
      }
    } else {
      this.readyRoutineCompleted = true;
    }
  },

  computed: {
    ...mapState(["publicPoll", "project"]),
    votingRestrictionByEmail() {
      return this.publicPoll.configuration.votingRestrictionByEmail;
    },
    onTimeToVoting() {
      if (
        !this.publicPoll ||
        !this.publicPoll.configuration ||
        this.publicPoll.data.pageType !== "VOTING_PORTAL"
      ) {
        return "ignore";
      }
      const config = this.publicPoll.configuration;
      const currentDate = new moment();
      if (currentDate.isBefore(config.publicationDate)) {
        return "not_publish";
      }
      const deadline = config.deadlineForVotingOnProjects;
      if (currentDate.isBefore(deadline.from)) {
        return "before";
      }
      if (currentDate.isBetween(deadline.from, deadline.to)) {
        return "on_time";
      }
      return "after";
    },
    votingPortal() {
      return this.publicPoll
        ? this.publicPoll.data.pageType === "VOTING_PORTAL"
        : false;
    },
  },

  methods: {
    ...mapActions([
      "getPublicPoll",
      "getProjectData",
      "makeVote",
      "validateVoteToken",
    ]),
    formatDate(dateStr) {
      return getBRDateTime(dateStr);
    },
    showErrorAlert(errorMessage) {
      this.errorSnackbarMsg = errorMessage;
      this.$refs.errorSnackbar.show();
    },
    showSuccessAlert(successSnackbarMsg) {
      this.successSnackbarMsg = successSnackbarMsg;
      this.$refs.successSnackbar.show();
    },
    openProsasEntrepeneur(id) {
      window.open("https://prosas.com.br/empreendedores/" + id, "__blank");
    },
    openFacebookDialog() {
      window.open(
        "http://www.facebook.com/sharer.php?u=" + window.location,
        "sharer",
        "toolbar=0,status=0,width=548,height=325"
      );
    },
    openLinkedinDialog() {
      window.open(
        "https://www.linkedin.com/shareArticle?mini=true&amp;url=" +
          window.location,
        "sharer",
        "toolbar=0,status=0,width=548,height=325"
      );
    },
    openTwitterDialog() {
      window.open(
        "https://twitter.com/share?url=" + window.location,
        "sharer",
        "toolbar=0,status=0,width=548,height=325"
      );
    },
    async checkSocialMovies() {
      if (
        this.project &&
        this.project.movies &&
        this.project.movies.length > 0
      ) {
        this.project.movies = this.project.movies.map((movie) => {
          const currentMovie = movie;
          currentMovie["config"] = this.socialMovie(movie.link);
          return currentMovie;
        });
      }
    },
    async setPublicPollConfigurations() {
      if (!this.publicPoll) {
        return;
      }
      let pollConfig = this.publicPoll.configuration;
      if (pollConfig.projectDataForDisplay) {
        const display = pollConfig.projectDataForDisplay;
        this.siteConfiguration.projectDataForDisplay = display;
        let tabs = initialTabs;
        if (
          display.entrepreneurName ||
          display.entrepreneurType ||
          display.entrepreneurAbout ||
          display.entrepreneurFoundedOn
        ) {
          tabs = [
            {
              name: "Proponente",
              component: PollViewEntrepreneur,
            },
            ...tabs,
          ];
        }

        if (display.evaluation) {
          tabs = [
            ...tabs,
            {
              name: "Avaliações",
              component: PollViewEvaluation,
            },
          ];
        }
        this.tabs = tabs;
      }

      this.siteConfiguration.publicationDate = pollConfig.publicationDate;
      this.siteConfiguration.scoreAsPrivate = pollConfig.scoreAsPrivate;
      this.siteConfiguration.customLink = pollConfig.customLink;
      this.siteConfiguration.voteLimitPerEmail = pollConfig.voteLimitPerEmail;
      this.siteConfiguration.votingRestrictionByEmail =
        pollConfig.votingRestrictionByEmail;
      this.siteConfiguration.deadlineForVotingOnProjects =
        pollConfig.deadlineForVotingOnProjects;
      this.siteConfiguration.pageType = this.publicPoll.data.pageType;
    },
    showField(fieldName) {
      if (this.project === null || this.project == undefined) {
        return false;
      }

      return this.siteConfiguration.projectDataForDisplay[fieldName];

      // switch (fieldName) {
      //   case 'votingRestrictionByEmail': {
      //     return this.validateSiteConfigurationField('votingRestrictionByEmail');
      //   }
      //   default: {
      //     const validValue = this.validateSiteConfigurationField('votingRestrictionByEmail');
      //     return validValue && this.project.description;
      //   }

      // }
    },
    validateSiteConfigurationField(fieldName) {
      if (this.siteConfiguration[fieldName]) {
        return true;
      }
    },
    getPollConfiguration(configurationTypeName) {
      let configurationType = null;

      this.siteConfiguration.filter((configuration) => {
        if (configuration.name === configurationTypeName) {
          configurationType = configuration;
        }
      });

      return configurationType;
    },
    async validateToken(token) {
      try {
        await this.$store.dispatch("validateVoteToken", {
          token,
          domain: this.domain
        });
        this.showSuccessAlert("Voto validado com sucesso!");
        this.$store.commit("incrementProjectVote");
      } catch (error) {
        if (error.message === expiredTokenMessage) {
          return this.showErrorAlert(
            "Seu voto não foi confirmado. Por favor solicite outro email para votar"
          );
        }
        this.showErrorAlert(
          "Ocorreu um erro ao validar seu voto." + "\nERRO: `$(error)`"
        );
      }
    },
    socialMovie(link) {
      const youtubeRegex =
        /(?:https?:\/\/)?(?:www\.)?youtu\.?be(?:\.com)?\/?.*(?:watch|embed)(?:.*v=|v\/|\/)([\w\-_]+)\&?/;
      const vimeoRegex =
        /(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?/;
      const youtube = link.match(youtubeRegex);
      const vimeo = link.match(vimeoRegex);
      if (youtube) {
        return {
          type: "youtube",
          link: "https://www.youtube.com/embed/" + youtube[1],
          id: youtube[1],
        };
      } else if (link.includes("youtu.be")) {
        return {
          type: "youtube",
          link: link
            .replace("youtu.be", "www.youtube.com")
            .split("com/")
            .reduce((arr, item, index) => {
              const currentArr = arr;
              switch (index) {
                case 0:
                  currentArr[index] = item + "com";
                  break;
                case 1:
                  currentArr[index] = "embed";
                  currentArr[index + 1] = item;
                  break;
              }
              return currentArr;
            }, [])
            .join("/"),
          id: link.split("/").slice(-1).pop(),
        };
      } else if (vimeo) {
        return {
          type: "vimeo",
          link: "https://player.vimeo.com/video/" + vimeo[1],
          id: vimeo[1],
        };
      }
      return {
        type: "any",
        link,
      };
    },
  },
};
</script>

<style>
  .degrade {
    background-image: linear-gradient(
      to top,
      rgba(55, 71, 79, 0.8),
      rgba(51, 71, 79, 0.3),
      rgba(255, 255, 255, 0.1)
    );
    z-index: 1;
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 1;
    display: inline-block;
    min-height: 315px;
    max-width: 1164px;
  }

  span.titlestatus {
      font-size: 12px;
      font-weight: bold;
      color: #575757;
      line-height: 14px;
  }

  .buttonwhatsapp {
    margin-bottom: 67px !important;
    display: flex !important;
    -webkit-box-align: center !important;
    align-items: center !important;
    float: right !important;
    border-radius: 30px 8px 30px 30px !important;
    background-color: #075E54 !important;
    box-shadow: none !important;
    color: rgb(255, 255, 255) !important;
    z-index: 2147483647 !important;
    cursor: pointer !important;
    padding: 12px 20px !important;
    transition: all 0.1s ease-out 0s !important;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
    -webkit-font-smoothing: antialiased !important;
    margin-right: 20px !important;
    bottom: 0 !important;
    position: fixed !important;
    right: 0 !important;
  }
  .buttonwhatsappHelp {
      float: right !important;
      color: #fff !important;
      font-size: 16px !important;
      font-weight: 700 !important;
      margin: 0 !important;
      padding: 0 !important;
      line-height: 29px !important;
  }
</style>


// WEBPACK FOOTER //
// src/pages/poll/ProjectView.vue